import { Button } from 'components/Button';
import { ICONS } from 'components/Icon';
import { Page } from 'components/Page';
import { TEXT_SIZE_XLARGE, TEXT_SIZE_XSMALL, Txt } from 'components/Txt';
import { theme } from 'lib/theme';
import * as React from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { doCloudPropertiesOpen } from 'store/search/actions';

import { LocalAssetsHeader } from './LocalAssetsHeader';
import { ButtonGroup } from 'components/ButtonGroup';

type Props = {
  inPages: boolean;
};

export const NoLocalAssets: React.FC<Props> = ({ inPages }) => {
  const dispatch = useDispatch();
  const { height } = useWindowDimensions();
  const shortScreen = height < 400;

  const openSearch = React.useCallback(
    () => dispatch(doCloudPropertiesOpen()),
    [dispatch],
  );
  return (
    <Page
      scrollView={false}
      backgroundColor="transparent"
      paddingBottom={0}
      paddingTop={0}
      header={<LocalAssetsHeader inPages={inPages} />}
      headerBackgroundColor="transparent"
      showFloatingHeaderFade={false}
    >
      <View
        style={
          shortScreen
            ? styles.scrollContainerShort
            : {
                // backgroundColor: 'blue',
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
              }
        }
      >
        <Txt size="xlarge" weight="bold">
          Work Offline
        </Txt>
        <Txt
          style={[
            styles.bodyText,
            shortScreen ? styles.bodyTextShort : undefined,
          ]}
        >
          {shortScreen
            ? 'Perform assessments anywhere, no internet connection required'
            : 'Perform assessments anywhere,\nno internet connection required'}
        </Txt>

        <Txt size="xlarge" weight="bold">
          Stay Up-to-date
        </Txt>
        <Txt
          style={[
            styles.bodyText,
            shortScreen ? styles.bodyTextShort : undefined,
          ]}
        >
          {shortScreen
            ? 'Changes sync automatically with RiskBase when you’re back online'
            : 'Changes sync automatically with\nRiskBase when you’re back online'}
        </Txt>

        <Txt size="xlarge" weight="bold">
          Get Started
        </Txt>
        <Txt
          style={[
            styles.bodyText,
            shortScreen ? styles.bodyTextShort : undefined,
          ]}
        >
          {shortScreen
            ? 'Download properties to begin and they’ll appear here'
            : 'Download properties to begin\nand they’ll appear here'}
        </Txt>

        <ButtonGroup>
          <Button
            icon={ICONS.ArrowDownLight}
            onPress={openSearch}
            text="Download Properties"
          />
        </ButtonGroup>
      </View>
    </Page>
  );
};

const styles = StyleSheet.create({
  bodyText: {
    fontSize: TEXT_SIZE_XLARGE,
    marginBottom: theme.paddingVertical,
    textAlign: 'center',
  },
  bodyTextShort: {
    marginBottom: TEXT_SIZE_XSMALL,
  },
  scrollContainerShort: {
    alignSelf: 'flex-start',
    paddingHorizontal: theme.grid,
    paddingVertical: 0,
  },
});
